<template>
    <div class="form-group residence-box">
        <div class="d-flex justify-content-between">
            <strong>{{ tra.accommodation }}:</strong>
            <span v-if="dataObj.residence && dataObj.residence.price" class="text-main-color">
                {{ dataObj.residence.price }}
                <span class="small text-dark">
                    {{ (dataObj.currency?.code || 'SAR') == 'SAR' ? ' ' : (dataObj.currency?.code || 'SAR') }}
                </span> 
                <span class="h6 text-main-color">
                    ({{ residenceWeeks + (residenceWeeks == 1 ? ' ' + tra.weeks_singular + ' ' : ' ' + tra.weeks + ' ') }})
                </span>
            </span>
        </div>

        <div class="row">
            <div class="col-xl-6">
                <div>
                    {{ dataObj.residence?.description || '' }}
                    <br>
                    <strong
                        v-if="dataObj.residence?.available_date_end != null && dataObj.residence?.available_date_from != null"
                        class="text-main-color"
                    >
                        ( {{ tra.available_only_from }}
                        {{ formatDate(dataObj.residence.available_date_from) }} {{ tra.to }}
                        {{ formatDate(dataObj.residence.available_date_end) }} )
                    </strong>
                </div>
            </div>
            <div class="col-xl-6 text-left">
                <button 
                    type="button" 
                    data-toggle="modal" 
                    data-target="#residences-modal"
                    class="btn rounded-10 text-white bg-secondary-color mt-2 py-1 w-100"
                >
                    {{ tra.browse_accommodation_options }}
                </button>
            </div>
        </div>

        <span v-if="postErrors.residence_id && !residenceId" class="h6 text-danger">
            ( {{ postErrors.residence_id[0] }} )
        </span>

        <div v-if="dataObj.residence != 0" class="form-group">
            <label>{{ tra.accommodation_weeks_number }}</label>
            <select 
                @change="$emit('institute-vacation-check')" 
                name="residence_weeks"
                :value="residenceWeeks"
                @input="$emit('update-residence-weeks', $event.target.value)"
                class="form-control rounded-10 border"
                data-live-search="true"
            >
                <option v-for="week_count in weeksCount" :value="week_count" :key="week_count">
                    {{ week_count }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ResidenceSection',
    props: {
        dataObj: Object,
        residenceWeeks: [String, Number],
        weeksCount: Number,
        postErrors: Object,
        tra: Object,
        residenceId: [String, Number],
    },
    emits: ['update-residence-weeks', 'institute-vacation-check'],
    methods: {
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        }
    }
};
</script>